export default __webpack_public_path__ + "static/wx-cbb4b0ddbe6a44a16f56ff0561707848.jpg";